export default __webpack_public_path__ + "static/media/right-angle.47b565f0.svg";